import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  "fill-opacity": ".5",
  "fill-rule": "evenodd",
  d: "M5 2a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2zm5 5a1 1 0 0 0-.53.151l-4.984 2.992a1 1 0 0 0 1.029 1.714L9 9.768V17a1 1 0 1 0 2 0V9.766l3.486 2.092a1 1 0 0 0 1.028-1.716l-4.986-2.991A1 1 0 0 0 10 7",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }